import React from 'react';
import './VisiMisi.css'; // Menggunakan file CSS khusus
import { FaBullseye, FaTasks } from 'react-icons/fa'; // Impor ikon

const VisiMisi = ({ visi, misi }) => {
  return (
    <section className="section visi-misi-section">
      <div className="container">
        <div className="visi-misi-grid">
          <div className="visi-card">
            <h3><FaBullseye /> Visi</h3>
            <p>{visi || "Visi sekolah belum diatur."}</p>
          </div>
          <div className="misi-card">
            <h3><FaTasks /> Misi</h3>
            {misi ? (
              <ul>
                {misi.split('\n').map((item, index) => (
                  item.trim() && <li key={index}>{item}</li>
                ))}
              </ul>
            ) : <p>Misi sekolah belum diatur.</p>}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisiMisi;